import { render, staticRenderFns } from "./exhibition-photo.vue?vue&type=template&id=802b8458&scoped=true&"
import script from "./exhibition-photo.vue?vue&type=script&lang=js&"
export * from "./exhibition-photo.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-photo.vue?vue&type=style&index=0&id=802b8458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802b8458",
  null
  
)

export default component.exports